/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Phone_InvalidInputs */

const es_co2_error_phone_invalid = /** @type {(inputs: Error_Phone_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El teléfono no es válido. Usa formato internacional, p. ej. +573001234567.`)
};

/**

* @param {Error_Phone_InvalidInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_phone_invalid = /** @type {((inputs?: Error_Phone_InvalidInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Phone_InvalidInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_phone_invalid(inputs)
});